function Copyright() {
  return (
    <>
      <title>Copyright Policy - vidi3D</title>
      <meta name="robots" content="noindex" />
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-4xl mx-auto p-8">
          <h1 className="text-6xl font-bold text-brand text-center py-12 mb-8">Copyright Policy</h1>

          <div className="grid gap-8">
            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">1. Copyright Protection</h2>
              </div>
              <p className="text-brand-dark mb-4">All content on this website, including but not limited to:</p>
              <ul className="space-y-3 text-brand-dark">
                {["3D virtual tours", "Images and photographs", "Text and descriptions", "Logos and branding elements", "Website design and layout"].map((item) => (
                  <li key={item} className="flex items-center">
                    <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-brand-dark mt-4">is the property of vidi3D and is protected by international copyright laws.</p>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">2. Permitted Use</h2>
              </div>
              <p className="text-brand-dark mb-4">Users may:</p>
              <ul className="space-y-3 text-brand-dark">
                {["View content for personal, non-commercial use", "Share links to our content", "Use our services as intended through official channels"].map((item) => (
                  <li key={item} className="flex items-center">
                    <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">3. Prohibited Use</h2>
              </div>
              <p className="text-brand-dark mb-4">Without explicit written permission, users may not:</p>
              <ul className="space-y-3 text-brand-dark">
                {["Copy, reproduce, or download any content", "Modify or create derivative works", "Distribute or publicly display our content", "Use our content for commercial purposes", "Remove any copyright notices or branding"].map((item) => (
                  <li key={item} className="flex items-center">
                    <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">4. Client Content</h2>
              </div>
              <p className="text-brand-dark mb-4">For virtual tours and content created for clients:</p>
              <ul className="space-y-3 text-brand-dark">
                {["Usage rights are specified in individual service agreements", "Clients retain ownership of their original content", "vidi3D maintains rights to the virtual tour technology and implementation"].map((item) => (
                  <li key={item} className="flex items-center">
                    <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">5. Copyright Infringement</h2>
              </div>
              <p className="text-brand-dark mb-4">If you believe your copyright has been infringed, please contact us with:</p>
              <ul className="space-y-3 text-brand-dark mb-4">
                {["Description of the copyrighted work", "Location of the infringing material", "Your contact information", "Statement of good faith belief", "Statement of accuracy under penalty of perjury"].map((item) => (
                  <li key={item} className="flex items-center">
                    <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-brand-dark">Send notices to: <a href="mailto:copyright@vidi3d.com" className="text-brand hover:underline">copyright@vidi3d.com</a></p>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">6. Updates to Policy</h2>
              </div>
              <p className="text-brand-dark">We reserve the right to update this copyright policy at any time. Continued use of our services constitutes acceptance of any changes.</p>
            </section>

            <footer className="text-center text-gray-600 py-8">
              <p>Last updated: January 2025</p>
              <p>© {new Date().getFullYear()} vidi3D. All rights reserved.</p>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
}

export default Copyright;